import * as React from 'react';

import { useSelector } from 'react-redux';
import { selectGamesLoading, selectProvidersByCategory } from '@/store/selectors/gamesSelectors';
import EmptyGamesPlaceholder from '@/pages/games/EmptyGamesPlaceholder';
import { BffGamesCategory } from '@lucky7ventures/bff-types';
import GamesByProviderSkeletonLoader from '@/components/shared/skeleton-loader/GamesByProviderSkeletonLoader';
import GamesProvidersInfiniteGrid from '@/pages/games/GameProvidersInfiniteGrid';
import GameProvidersHeader from '@/pages/games/GameProvidersHeader';
import { useIntl } from 'react-intl';
import { useAbsoluteNavigate } from '@/hooks/useAbsoluteNavigate';

function ProvidersByCategory({ category }: { category: BffGamesCategory }): JSX.Element {
  const intl = useIntl();
  const providers = useSelector(selectProvidersByCategory(category));
  const gamesLoading = useSelector(selectGamesLoading);
  const navigate = useAbsoluteNavigate();

  const providerClicked = (providerSlug: string) => {
    navigate(`/games/${providerSlug}/cat/${category}`);
  };

  if (gamesLoading) {
    return <GamesByProviderSkeletonLoader />;
  }

  if (!gamesLoading && !providers) {
    return <EmptyGamesPlaceholder category={BffGamesCategory.AllGames} />;
  }

  return (
    <div className="py-16">
      <GameProvidersHeader
        header={intl.formatMessage({ id: 'games.nav.providers' })}
        subheader={intl.formatMessage({ id: `games.categories.${category}` })}
        count={providers.length}
        loading={gamesLoading}
      />
      <GamesProvidersInfiniteGrid
        providers={providers}
        loading={gamesLoading}
        onProviderClicked={providerClicked}
      />
    </div>
  );
}

export default ProvidersByCategory;
